import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import storage from "../../../components/DeviceStorage/DeviceStorage";
import settings from "../../../devices/all/settings";
import store from '../../../store';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class IsFavoriteTask extends AbstractRequestTask {
  constructor(contentType = "", user, params, headers) {
    super();
    this._config = getAppConfig();
    this._service = "isFavorited";
    this._user = user;
    this.method = params.method;
    const region = storage.getItem("region");
    const { tenant_code } = settings;

    this._params = {
      ...params,
      authpn: this._config.authpn,
      authpt: this._config.authpt,
      device_type: this._config.device_type,
      device_model: this._config.device_model,
      device_manufacturer: this._config.device_manufacturer,
      device_category: this._config.device_category,
      device_id: this._config.device_id,
      tenant_code: tenant_code,
      region: region,
      format: this._config.format,
      contentType,
      contentId: params.contentId,
      cm_access_token: store.getState().user.musicUser.cm_access_token
    };
    this._headers = headers || {};
  }

  getMethod() {
    if (this.method) return this.method;
    return "GET";
  }

  getEncType() {
    if (this.getMethod() === "POST") return "multipart/form-data";

    return "application/x-www-form-urlencoded";
  }

  isValid(data) {
    if (
      data.errors &&
      !data.ribbons &&
      !data.albumDetail &&
      !data.playlistDetail
    ) {
      return false;
    }
    return true;
  }

  getUrl() {
    return `${this._config.end_point_music}/middleware/user/${this._service}`;
  }

  getParams() {
    const params = this._params;
    delete params.method;
    params.version = '1.0.0';

    return { ...this._params };
  }

  getHeaders() {
    const headers = {
      ...this._headers
    };
    return headers;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default IsFavoriteTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/IsFavoriteTask.js